'use client'
import {
  HAS_ALL_ACCESS,
  LOGGED_IN,
} from '@repo/web-ui/components/static-variants-renderer/utils/conditions'
import { InlineStaticVariant } from '@repo/web-ui/components/static-variants-renderer/inline/inline-static-variant'
import * as React from 'react'
import { useTranslations } from 'next-intl'
import { usePricesForUser } from '@repo/cf-user/hooks/use-prices'
import { PAYMENT_ENTRY_POINTS } from 'payments/payments-dialog/analytics'
import { StartFreeTrialButton } from 'payments/start-free-trial-button'

export function InlineStaticVariantsButton() {
  const t2 = useTranslations('pages.search')
  const { currency } = usePricesForUser()

  return (
    <InlineStaticVariant
      conditions={[LOGGED_IN, HAS_ALL_ACCESS]}
      getVariant={React.useCallback(
        ({ conditionsMet }) =>
          conditionsMet ? (
            <></>
          ) : (
            <StartFreeTrialButton
              label={t2('trial_product_card_variant.cta', {
                currency: currency.symbol,
              })}
              entryPoint={PAYMENT_ENTRY_POINTS.BUNDLES_BANNER}
              className="text-14 text-cf-white bg-secondary-500 hover:bg-secondary-700 flex min-h-[40px] w-full items-center justify-center rounded-[2px] px-5 text-center font-semibold uppercase"
            />
          ),
        [currency.symbol, t2],
      )}
    />
  )
}
